<template>
  <div class="wrp">
    <div class="back">
      <span @click="goback"><i class="el-icon-back"></i>Back</span>
    </div>
    <div class="venue-name">{{venueName}}</div>
    <ul class="hover-header tab clear" v-if="$route.path.split('/')[2] !== 'inner' && $route.path.split('/')[2] !== 'deputy'">
      <router-link tag="li" :to="'/detail/info/'+id" :class="{'active': $route.path.split('/')[2] == 'info'}"><span>Venue Information</span></router-link>
      <router-link tag="li" :to="'/detail/proloss/'+id" :class="{'active': $route.path.split('/')[2] == 'proloss'}"><span>Profit & Loss</span></router-link>
      <router-link tag="li" :to="'/detail/week/'+id" :style="{'display': !currentBind ? 'none' : 'block'}"
      :class="{'active': $route.path.split('/')[2] == 'week' || $route.path.split('/')[2] == 'inner'}">
        <span v-if="currentBind === 'deputy'">Deputy Roster</span>
        <span v-if="currentBind === 'tanda'">Tanda Roster</span>
      </router-link>
      <router-link tag="li" :to="'/detail/labour/'+id" :class="{'active': $route.path.split('/')[2] == 'labour'}"><span>Labour History</span></router-link>
      <!--<router-link tag="li" :to="'/detail/employee/'+id" :class="{'active': $route.path.split('/')[2] == 'employee'}"><span>Employee List</span></router-link>-->
      <router-link tag="li" :to="'/detail/profit/'+id" :class="{'active': $route.path.split('/')[2] == 'profit'}"><span>Profit</span></router-link>
      <router-link tag="li" :to="'/detail/cost/'+id" :class="{'active': $route.path.split('/')[2] == 'cost'}"><span>Cost Distribution</span></router-link>
      <router-link tag="li" :to="'/detail/expense/'+id" :class="{'active': $route.path.split('/')[2] == 'expense'}"><span>Expense Type</span></router-link>
      <router-link tag="li" :to="'/detail/shift-configuration/'+id" :class="{'active': $route.path.split('/')[2] == 'shift-configuration'}"><span>Shift Configuration</span></router-link>
    </ul>
    <router-view />
  </div>
</template>

<script>
import api from '../../api/account'

export default {
  data () {
    return {
      id: this.$route.params.id,
      venueName: '',
      currentBind: ''
    }
  },
  created () {
    api.venueAccntDetail({
      params: parseInt(this.$route.params.id),
      callback: (res) => {
        if(res.data.code == 0){
          this.currentBind = res.data.data.rosterType ? res.data.data.rosterType : null
          this.venueName = res.data.data.venueName
        }
      }
    })
  },

  methods: {
    goback () {
      if (sessionStorage.getItem('page') || sessionStorage.getItem('key') || sessionStorage.getItem('startTimeStamp')) {
        let data = {
          page: sessionStorage.getItem('page')
        }
        if (sessionStorage.getItem('startTimeStamp'))
          data.startTimeStamp = sessionStorage.getItem('startTimeStamp')
        if (sessionStorage.getItem('endTimeStamp'))
          data.endTimeStamp = sessionStorage.getItem('endTimeStamp')
        if (sessionStorage.getItem('key'))
          data.key = sessionStorage.getItem('key')
        if (sessionStorage.getItem('time'))
          data.time = sessionStorage.getItem('time')

        if (this.$route.path.split('/')[2] === 'inner' || this.$route.path.split('/')[2] === 'deputy')
          this.$router.go(-1)
        else
          this.$router.push({name: 'account', params: data})
      }
      else {
        if (this.$route.path.split('/')[2] === 'inner' || this.$route.path.split('/')[2] === 'deputy')
          this.$router.go(-1)
        else
          this.$router.push('/account')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .back{
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 36px;
    font-family: 'SFProText-Semibold';
    background: #212429;
    width: 100%;
    z-index: 5;
    height: 20px;
    span{
      display: inline-block;
      width: 100px;
      cursor: pointer;
      i{
        margin-right: 10px;
      }
    }
  }
  .venue-name{
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 33px;
    margin-bottom: 30px;
  }
  .tab{
    margin-bottom: 20px;
    li{

      @include pingfang-font(18px, normal, 500, $white) {
        float: left;
        margin-right: 40px;
        height: 35px;
        cursor: pointer;
        margin-bottom: 10px;
      }
      span{
        display: inline-block;
        height: 35px;
        position: relative;
        color: #A6A7A9;
      }
    }
    .active{
      span{
        color: #Fff;
        border-bottom: 2px solid #EA3796;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/detail.vue